/**
 * Created by bas.
 */

'use strict';

//window.MODE_PORTAL = true;

var keys           = require('stb-keys'),
    gettextWrapper = require('mag-gettext'),
    Emitter        = require('cjs-emitter'),
    daemon         = {
        triggers: [],
        standbyOn: function () {
            this.triggers.forEach(function ( item ) {
                if ( typeof item.standbyOn === 'function' ) {
                    item.standbyOn();
                }
            });
        },
        standbyOff: function () {
            this.triggers.forEach(function ( item ) {
                if ( typeof item.standbyOff === 'function' ) {
                    item.standbyOff();
                }
            });
        }
    },
    gettext;


function standByToggle ( data ) {
    var standByStatus = !gSTB.GetStandByStatus(),
        standByMode   = gSTB.StandByMode;

    if (
        data && data.action
        && ((data.action === 'on' && !standByStatus) || (data.action === 'off' && standByStatus))
    ) {
        // we already in this mode so no need for any actions
        return;
    }
    // ministra/stalker should use only active standby
    if ( window.MODE_STALKER ) {
        standByMode = gSTB.StandByMode = 1;
    }

    if ( standByMode === 3 ) {
        // deep standBy mode
        daemon.standbyOn();
        // need some time to send message to other apps
        setTimeout(function () {
            //console.log('standby-> Go to deep');
            gSTB.SetLedIndicatorMode(2);
            gSTB.StandBy(standByStatus);
            // deep standby is a sync operation so following js code will be executed
            // only after next POWER button press (C++ will wake up box)
            gSTB.SetLedIndicatorMode(1);
            daemon.standbyOff();
            //console.log('standby-> exit from deep');
        }, 1000);
    } else if ( standByMode === 1 ) {
        // active standBy mode
        if ( standByStatus ) {
            //console.log('standby-> Go to active');
            daemon.standbyOn();
            gSTB.SetLedIndicatorMode(2);
            gSTB.StandBy(standByStatus);
            gSTB.Stop();
        } else {
            //console.log('standby-> exit from active');
            gSTB.StandBy(standByStatus);
            gSTB.SetLedIndicatorMode(1);
            daemon.standbyOff();
        }
    }
}


function build ( config ) {
    var result;

    // stalker always use 'active stand by mode' so no need for options
    // also if we have only 1 option for select no need to show this setting
    if ( window.MODE_PORTAL && gSTB.SupportedStandByModes && gSTB.SupportedStandByModes.length > 1 ) {
        result = {
            content: [
                {
                    id: 'standby',
                    parent: 'system',
                    type: 'option',
                    name: gettext('Stand by mode'),
                    description: [
                        {
                            label: gettext('Mode') + ':',
                            value: ['', gettext('Active'), '', gettext('Deep')][gSTB.StandByMode] || ''
                        }, {
                            label: '',
                            value: gettext('Selecting standby mode:\nDeep - all applications complete their work\nActive - most of the systems work, the screen dims and the player stops\nThese modes are activated by pressing the Power button on the remote control.') // eslint-disable-line
                        }
                    ],
                    icon: 'theme-icon-standby',
                    environment: {standByMode: gSTB.StandByMode},
                    render: config.api.renders.popupSelect,
                    getter: config.api.getters.environment,
                    prepareForRender: function ( data, callback ) {
                        callback([
                            {value: 1, name: gettext('Active'), selected: gSTB.StandByMode === 1},
                            {value: 3, name: gettext('Deep'), selected: gSTB.StandByMode === 3}
                        ]);
                    },
                    prepareForSave: function ( value, callback ) {
                        //console.log('standby:was ' + gSTB.StandByMode + ' set to ' + value);
                        gSTB.StandByMode = value;
                        // instant new value apply
                        gSTB.SetEnv(JSON.stringify({standByMode: gSTB.StandByMode}));
                        // tell core about new value
                        this.environment['standByMode'] = value;
                        callback();
                    },
                    saver: config.api.savers.environment
                }
            ]
        };
    } else {
        result = {content: []};
    }

    return result;
}


function Client () {
    var self    = this,
        trigger = {};

    Emitter.call(this);

    trigger.standbyOn = function () {
        if ( self.events['standbyOn'] ) {
            try {
                self.emit('standbyOn');
            } catch ( error ) {
                console.log('standby plugin: error in one of standbyOn listeners. ' + error);
            }
        }
    };
    trigger.standbyOff = function () {
        if ( self.events['standbyOff'] ) {
            try {
                self.emit('standbyOff');
            } catch ( error ) {
                console.log('standby plugin: error in one of standbyOff listeners. ' + error);
            }
        }
    };

    daemon.triggers.push(trigger);

    /**
     * Stop this client and remove all it listeners. Use it for cleanup before application exit.
     */
    this.destroy = function () {
        daemon.triggers.splice(daemon.triggers.indexOf(trigger), 1);
        this.events = {};
    };
}


Client.prototype = Object.create(Emitter.prototype);
Client.prototype.constructor = Client;


module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var envStandByMode = Number(JSON.parse(gSTB.GetEnv(JSON.stringify({varList: ['standByMode']}))).result.standByMode);

            gettext = gettextWrapper.gettext;
            // if value is empty replace with default
            if ( window.MODE_PORTAL && envStandByMode === '' ) {
                gSTB.SetEnv(JSON.stringify({standByMode: gSTB.StandByMode}));
            }
            // apply standby mode according to user settings
            if ( gSTB.SupportedStandByModes && gSTB.SupportedStandByModes.indexOf(envStandByMode) !== -1 ) {
                gSTB.StandByMode = envStandByMode;
            }
            // add listener for power button (keydown code is 85+alt)
            window.core.addListener('keydown:' + keys.power, function ( data ) {
                //console.log('power button keydown');
                if ( data.altKey ) {
                    standByToggle();
                }
            });
            // add listener for system plugins (for example hdmi reaction plugin can turn on/off standby)
            window.system.addListener('standby', function ( data ) {
                //console.log('standby from system with data');
                //console.log(JSON.stringify(data));
                standByToggle(data);
            });
            // add listener for stand by event from legacy portal (for example magic cast nano-core build)
            if ( !window.MODE_PORTAL && !window.MODE_STALKER ) {
                window.stbEvent.addListener('message', function ( data ) {
                    if ( data.message === 'portal.standbyMode' ) {
                        standByToggle(data);
                    }
                });
            }

            callback();
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, new Client());
    },
    onSettingsInit: function ( config, callback ) {
        callback(null, build(config));
    }
};
